import React from 'react';
import { Tabs, Button, Spin, Table, DatePicker, Space, ConfigProvider,Radio, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { APIService } from '../../../services/appraisement/api';
import { returnIframeUrl } from "../../../lib/http";
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import { CalendarTimeService } from '../../../services/calendar/calendar.tool.service.js';
import echarts from 'echarts';// 引入echarts
import 'echarts/lib/chart/bar';// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import './TrendChart.scss'
import 'moment/locale/zh-cn';
import locale from "antd/es/date-picker/locale/zh_CN";
import moment from 'moment';
import zhCN from 'antd/es/locale/zh_CN';
moment.locale('zh-cn'); // 国际化

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

class SetLinechart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            PictureData: {}, // 走势图
            showPicture: false,
            TableData: [],
            showSpin: true,
            disabled: true, //  下载净值数据按钮
            chartTime:'all', //净值走势图日期切换
            pagination: {
                current: 1,
                pageSize: 15,
                showSizeChanger: false,
                total: 0,
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'index',
                    render: (text, record, index) => `${index + 1}`,
                    width: "80px",
                    align: "center"
                },
                {
                    title: '估值日期',
                    dataIndex: 'ValuationDate',
                },
                {
                    title: '今日单位净值',
                    dataIndex: 'Today_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 5}}>{record['Today_AssetValue']}</span>
                },
                {
                    title: '累计单位净值',
                    dataIndex: 'Add_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 5}}>{record['Add_AssetValue']}</span>
                },
                {
                    title: 'A类单位净值',
                    dataIndex: 'A_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 5}}>{record['A_AssetValue']}</span>
                },
                {
                    title: 'A类累计单位净值',
                    dataIndex: 'A_Add_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 5}}>{record['A_Add_AssetValue']}</span>
                },
                {
                    title: 'B类单位净值',
                    dataIndex: 'B_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 5}}>{record['B_AssetValue']}</span>
                },
                {
                    title: 'B类累计单位净值',
                    dataIndex: 'B_Add_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 5}}>{record['B_Add_AssetValue']}</span>
                },
            ],
            columns_e:[
                {
                    title: '序号',
                    dataIndex: 'index',
                    width: 80,
                    align: "center",
                    render: (text, record, index) => `${index + 1}`
                },
                {
                    title: '估值日期',
                    dataIndex: 'ValuationDate',
                    align: 'right',
                },
                {
                    title: '今日单位净值',
                    dataIndex: 'Today_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 10}}>{record['Today_AssetValue']}</span>
                },
                {
                    title: '累计单位净值',
                    dataIndex: 'Add_AssetValue',
                    align: 'right',
                    render: (text, record) => <span style={{paddingRight: 10}}>{record['Add_AssetValue']}</span>
                },
            ],
            netValue: [],
            startTime: "",
            endTime: "",
            Grading:"",
            diagram:this.props.data.diagram.data || {}
        }
    }
    componentDidMount() {
        const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
        __waterDocumentSvg({
            container: document.getElementById('Movements'),
            // content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
            content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
            width: '700px',
            height: '550px',
            opacity: '0.1',
            fontSize: '26px',
            zIndex: 1000
        })

        this.FigureShows()
        // this.getGradingdata()
        let { diagram } = this.props.data

        this.setState({ Grading:diagram.is_classification})
    }
    FigureShows = () => {
        let { diagram } = this.state;
        console.log(diagram,'diagramdiagramdiagramdiagram');
        var myChart = echarts.init(document.getElementById('trend')); // 绘制图表

        myChart.setOption({
            // color: ['#FF5F60', '#F8BB3A', '#34A0F6', '#D8D8D8', '#00C272', '#FF6600', '#FDD647', '#4346D6', '#23C93F', '#F42434', '#00FFF7', '#6FC2FF', '#FF5685', '#50E3C2', '#6E47FD'],
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                icon: 'stack', // 设置成矩形
                itemWidth: 20,
                itemHeight: 5,
                data: diagram.legend,
                bottom: 0,
                textStyle:{
                    fontSize:14,
                }
            },
            grid: {
                left: '6%',
                right: '8%',
                bottom: 80,
                top: 25,
                containLabel: true
            },
            dataZoom: [
                {
                    show: true,
                    realtime: true,
                    bottom: 40,
                    textStyle:{
                        fontSize:14,
                    }
                }
            ],
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: diagram.xAxis,
                axisLabel:{
                    textStyle:{
                        fontSize:14,
                    }
                }
            },
            // yAxis: diagram.yAxis,
            yAxis:[
                {
                    name:'',
                    type:'value',
                    splitLine:{
                        type: 'dotted',
                    },
                    axisLabel:{
                        textStyle:{
                            fontSize:14,
                        }
                    }
                }
            ],
            series: diagram.series
        });

        // window.onresize = myChart.resize
    }

    getGradingdata = () => {
        let { data, diagram} = this.props.data;
        let { chartTime} = this.state;
        let param = {
            product_project_number: data.f6,
            latest_date:diagram.max_date,
            project_filter_field:chartTime
        }
        this.setState({showPicture:true})
        APIService.getNetWorthTrend(param).then(res => {
            console.log(res);
            if (res.success) {
                this.setState({diagram:res.data,showPicture:false},()=> {
                    this.FigureShows();
                })
            }else {
                this.setState({showPicture:false})
                message.error(res.error)
            }
        }).catch(err => {
            this.setState({showPicture:false})
            console.log(err)
        })
    }
    getValueTable = () => {
        let { data } = this.props.data
        let { startTime, endTime , Grading, pagination} = this.state;
        const {current,pageSize} = pagination;
        let param = {
            first: Number(current - 1) * pageSize,
            rows: pageSize,
            project_number: data.f6,
            start_time: startTime,
            end_time: endTime,
            is_classification: Grading
        }
        APIService.getHistoryValData(param).then(res => {
            if (res.success) {
                let netValue = this.createNetValue(res.data);
                this.setState({ 
                    TableData: res.data, 
                    netValue: netValue, 
                    pagination:{
                        ...this.state.pagination,
                        total:res.total_number,
                    },
                    showSpin: false 
                })
                if (res.data.length) {
                    this.setState({ disabled: false })
                }
            } else {
                message.error(res.error);
            }
        }).catch(err => {
            console.log('项目列表接口 Error', err)
        })
    }
    // 查询
    // getInformation = () =>{
    //     let { data } = this.props.data
    //     let { startTime, endTime } = this.state
    //     console.log(data);
    //     let param = {
    //         project_number:data.f6,
    //         start_time:startTime,
    //         end_time:endTime,
    //     }
    //     APIService.getHistoryValData(param).then(res => {
    //         if(res.success){
    //             console.log(res,'查询');
    //             this.setState({})
    //         }else {
    //             message.error(res.error);
    //         }
    //     }).catch(err => {
    //         console.log('项目查询接口 Error', err)
    //     })
    // }


    DownloadNet = () => {
        let { data } = this.props.data

        let param = {
            product_number: JSON.stringify(data.f6)
        }

        let url = returnIframeUrl('/citic/get_download_val_excel/', param);
        let aElement = document.createElement('a'); //创建节点
        document.body.appendChild(aElement);
        aElement.style.display = 'none';
        aElement.href = url;
        aElement.click();
        document.body.removeChild(aElement);
    }

    createNetValue = (TableData) => {
        let netValue = []
        TableData.map((item, index) => {
            netValue.push({
                key: index,
                ValuationDate: item.project_date,
                Today_AssetValue: item.day_company_val,
                Add_AssetValue: item.day_cumulative_val,
                A_AssetValue: item.a_company_val,
                A_Add_AssetValue: item.a_cumulative_val,
                B_AssetValue: item.b_company_val,
                B_Add_AssetValue: item.b_cumulative_val,
            });
        })
        return netValue;
    };
    chartTimeChange=(e)=> {
        this.setState({chartTime:e.target.value},()=> {
            this.getGradingdata()
        })
    }
    render() {
        let { showPicture , showSpin, PictureData, disabled, columns, netValue,columns_e ,Grading,pagination,chartTime } = this.state
        let { diagram } = this.props.data
        let t = window.devicePixelRatio
        return (
            <ConfigProvider locale={zhCN}>
                <div id="Movements">
                    <div className="outermost">
                        <Tabs
                            onChange={(e) => {
                                if(e == "2" ){
                                    this.getValueTable() // 历史净值
                                }else{
                                    this.setState({showPicture:true})
                                    setTimeout(() => {
                                        this.setState({showPicture:false})
                                    }, 1000);
                                }
                            }}
                            defaultActiveKey="1"
                            tabBarExtraContent={
                                // <Button type="primary" disabled={disabled} onClick={() => this.DownloadNet()}>
                                <Button type="primary" onClick={() => this.DownloadNet()}>
                                    {/* 下载净值数据 */}
                                    下载
                                </Button>
                            }
                        >
                            <TabPane tab="净值走势图" key="1">
                                <div className='Movements-Group'>
                                    <Radio.Group 
                                        value={chartTime} 
                                        onChange={this.chartTimeChange} 
                                    >
                                        <Radio.Button value="all">全部</Radio.Button>
                                        <Radio.Button value="0">近1月</Radio.Button>
                                        <Radio.Button value="1">近3月</Radio.Button>
                                        <Radio.Button value="2">近6月</Radio.Button>
                                        <Radio.Button value="3">近1年</Radio.Button>
                                        <Radio.Button value="4">近3年</Radio.Button>
                                    </Radio.Group>
                                </div>
                                <Spin size="large" spinning={showPicture}>
                                    <div id="trend" style={{zoom:t >=2 ? 1/0.7 : 1/(1/t) , height:`500px`,transform:`scale(${t >= 2 ? 0.7 : 1/t })`,transformOrigin:"0%0%", width: `${t >=2 ? 100 * (1/0.7) : 100 * t}%` }} key={`${diagram}`}></div>
                                </Spin>
                            </TabPane>
                            <TabPane tab="历史净值" key="2">
                                <span className='query_cycle'>
                                    <RangePicker
                                        className = "dateselect"
                                        locale={locale}
                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                        onChange={(start, time) => {
                                            console.log(start, time);
                                            this.setState({ startTime: time[0], endTime: time[1] })
                                        }}
                                    />
                                </span>
                                <Button
                                    type="primary"
                                    className="getInformation_btn"
                                    style={{ marginLeft: "20px" }}
                                    onClick={() => {
                                        this.setState({
                                            pagination:{
                                                ...this.state.pagination,
                                                current:1,
                                            }
                                        },()=> {
                                            this.getValueTable();
                                        })
                                    }}
                                >
                                    查询
                                </Button>
                                <Table
                                    // key={`${netValue}`}
                                    size="small"
                                    loading={showSpin}
                                    rowKey={record => record.key}
                                    className="Performance-Tab"
                                    columns={Grading == "是" ? columns : columns_e}
                                    dataSource={netValue}
                                    pagination={pagination}// 显示分页
                                    onChange={(pagination, filters, sorter) => {
                                        console.log(pagination,'pagination')
                                        this.setState((prev,props)=> {
                                            return {
                                                pagination:{
                                                    ...this.state.pagination,
                                                    current:pagination.current,
                                                    pageSize:pagination.pageSize
                                                }
                                            }
                                        },()=> {
                                            this.getValueTable()
                                        })
                                    }}
                                    rowClassName={(record, index) => {
                                        let className = 'dark-row';
                                        if (index % 2 === 1) className = 'light-row';
                                        return className;
                                    }}
                                    scroll={{
                                        y: 530
                                    }}
                                />
                            </TabPane>

                        </Tabs>
                    </div>
                </div>
            </ConfigProvider>
            
        )
    }
}

export default SetLinechart;


// WEBPACK FOOTER //
// app/components/customPage/TrendChart/TrendChart.jsx